import { INDICATION_TYPES, STATIC_INDICATION_TYPES } from '../../../../taboola-common-frontend-modules/Indications';
import { FormattedMessage } from '../../../../taboola-common-frontend-modules/i18n';
import { FILTER_TYPE } from '../../../modules/campaigns-reports/config/filters/filterType';

export const RECOMMENDED_MSV2_SITE_DYNAMIC_SORT_FILTERS = [FILTER_TYPE.TOP_RESULTS];
export const siteMSV2DynamicColumnsSortDisclaimer = {
    staticIndicationType: STATIC_INDICATION_TYPES.SITE_MSV2_DYNAMIC_COLUMNS_SORT_DISCLAIMER,
    type: INDICATION_TYPES.WARNING,
    highlight: (
        <FormattedMessage
            id="app.campaign.indication.site.msv2.report.dynamic.coll.sort.disclaimer.highlight"
            defaultMessage="Sorting Limited to First 50 Results"
        />
    ),
    message: (
        <FormattedMessage
            id="app.campaign.indication.site.msv2.report.dynamic.coll.sort.disclaimer"
            defaultMessage='- Apply the "Results" filter to sort more sites. Without this filter, sorting is only applied to the first 50 results due to system limitations.'
        />
    ),
};
